import React from 'react';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * AppLinkComponent
 * MUI Link wrapper with React Router integration
 */
const AppLinkComponent = ({
  to,
  href,
  children,
  color = '#64B5F6',
  underline = 'hover',
  variant = 'body2',
  sx = {},
  ...props
}) => {
  const baseProps = {
    color,
    variant,
    sx: {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
        opacity: 0.8,
      },
      ...sx,
    },
    ...props,
  };

  // Use React Router Link for internal navigation
  if (to) {
    return (
      <MuiLink 
        component={RouterLink} 
        to={to} 
        underline={underline === 'hover' ? 'hover' : underline === 'always' ? 'always' : 'none'}
        {...baseProps}
      >
        {children}
      </MuiLink>
    );
  }

  // Use regular MUI Link for external links
  return (
    <MuiLink 
      href={href} 
      underline={underline === 'hover' ? 'hover' : underline === 'always' ? 'always' : 'none'}
      {...baseProps}
    >
      {children}
    </MuiLink>
  );
};

AppLinkComponent.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  underline: PropTypes.oneOf(['none', 'hover', 'always']),
  variant: PropTypes.oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2']),
  sx: PropTypes.object,
};

export default AppLinkComponent;
